export const START_SOUND = 'gameStart';
export const END_SOUND = 'roundEnd';
export const CORRECT_ANSWER_SOUND = 'correct';
export const WRONG_ANSWER_SOUND = 'error';
export const LEVEL_UP_SOUND = 'levelUp';
export const RIGHT_BTN_VALUE = 'right';
export const WRONG_BTN_VALUE = 'wrong';

export const BASIC_XP = 10;
export const INITIAL_DIFFICULTY = 2;
export const INITIAL_ROUND = 2;
export const INITIAL_XP_LEVEL = 1;
export const INITIAL_XP_STEPPER_VALUE = -1;
export const XP_STEPPER_NUMBER = 2;
export const MAX_XP_LEVEL = 8;
export const RIGHT_CARD_CHANCE = 0.7;

export const WORD_LANGUAGE = 'en-US';
export const TRANSLATE_LANGUAGE = 'ru-RU';

export const LEFW_ARROW_KEY_CODE = 37;
export const RIGHT_ARROW_KEY_CODE = 39;

export const MEDIA_FILES_URL = 'https://raw.githubusercontent.com/irinainina/rslang-data/master/';
export const SERVER_URL = 'https://afternoon-falls-25894.herokuapp.com/';
